import type { ComponentType } from 'react';
import {
  BellIcon,
  BoltIcon,
  ClockIcon,
  DocumentCleanIcon,
  DocumentFilledIcon,
  FiltersIcon,
  GlobeIcon,
  GridIcon,
  HomeIcon,
  LinkIcon,
  MessageCircleDotsIcon,
  QuestionCircleIcon,
  SettingsIcon,
  StarIcon,
  UsersIcon,
} from '../../components/icons';

export const DEFAULT_DOC_ICON = 'document';

/** The curated set of glyphs a curator can pick for a recommended doc's card. */
export const DOC_ICONS = {
  document: { label: 'Document', Icon: DocumentCleanIcon },
  'document-filled': { label: 'Document (filled)', Icon: DocumentFilledIcon },
  globe: { label: 'Globe', Icon: GlobeIcon },
  users: { label: 'Team', Icon: UsersIcon },
  link: { label: 'Link', Icon: LinkIcon },
  bolt: { label: 'Quickstart', Icon: BoltIcon },
  settings: { label: 'Settings', Icon: SettingsIcon },
  star: { label: 'Star', Icon: StarIcon },
  clock: { label: 'Recent', Icon: ClockIcon },
  bell: { label: 'Announcement', Icon: BellIcon },
  home: { label: 'Home', Icon: HomeIcon },
  grid: { label: 'Overview', Icon: GridIcon },
  'message-circle-dots': { label: 'Discussion', Icon: MessageCircleDotsIcon },
  'question-circle': { label: 'FAQ', Icon: QuestionCircleIcon },
  filters: { label: 'Reference', Icon: FiltersIcon },
} satisfies Record<string, { label: string; Icon: ComponentType<{ className?: string }> }>;

export type DocIconKey = keyof typeof DOC_ICONS;

function isDocIconKey(key: string): key is DocIconKey {
  return key in DOC_ICONS;
}

/** Resolves a saved icon key to its glyph, falling back for an unknown or blank key. */
export function docIcon(key: string): ComponentType<{ className?: string }> {
  return (isDocIconKey(key) ? DOC_ICONS[key] : DOC_ICONS[DEFAULT_DOC_ICON]).Icon;
}
